import React, { useEffect, useState } from "react";
import ButtonLoading from "../general/ButtonLoading"; // Import ButtonLoading
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { logout } from "../../helper/helper"
function LoginForm({
  ftcLogo,
  errorStar,
  username,
  setUsername,
  password,
  setPassword,
  errorMessage,
  loading,
  handleLogin,

}) {
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const localTime = moment();
  //   const lowerBound = moment("6:59", "HH:mm");
  //   const upperBound = moment("7:00", "HH:mm");

  //   const userLoggedInDetails = localStorage.getItem("userLoggedInDetails");
  //   const token = localStorage.getItem("token");
  //   const userId = localStorage.getItem("userId");
  //   const staffRoles = localStorage.getItem("staffRoles");

  //   if (userLoggedInDetails && token && userId && staffRoles) {
  //     // ⚠️ Check if current time is *outside* of 6:59 to 7:00
  //     if (localTime.isAfter(lowerBound) || localTime.isBefore(upperBound)) {
  //       logout();
  //       navigate("/");
  //     } else {
  //       navigate("/staff-overview");
  //     }
  //   }
  // }, [navigate]);

  


  return (
    <div className="login-form">

      <img src={ftcLogo} alt="FTC Logo" className="FTCLogo" />
      <h3>Login</h3>
      <form action="/">
        <div className={`form-group ${errorStar ? "validationError" : null}`}>
          <input
            // style={{ color: errorStar ? "red" : "#3c4549" }}
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <label htmlFor="username" className="floatingLabel">
            Enter username or email
          </label>
        </div>

        <div className={`form-group ${errorStar ? "validationError" : null}`}>
          <input
            // style={{ color: errorStar ? "red" : "#3c4549" }}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label htmlFor="password" className="floatingLabel">
            Enter your password
          </label>
        </div>
        {errorMessage ? (
          <div className="form-group">
            <div className="" style={{color: "red" }}>
              {errorMessage}
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="form-group">
          <button className="button" onClick={(event) => handleLogin(event)}>
            {loading && <ButtonLoading />} Sign in
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
